import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingAnimationComponent } from './loading-animation/loading-animation.component';
import { AgmCoreModule } from '@agm/core';
import { SearchBarComponent } from './search-bar-component/search-bar-component.component';
import { FormsModule } from '@angular/forms';
import { SearchTextComponent } from 'src/app/home/search-text/search-text.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentHolderComponent } from './component-holder/component-holder.component';

@NgModule({
  declarations: [
    LoadingAnimationComponent,
    SearchBarComponent,
    SearchTextComponent,
    ComponentHolderComponent
  ],
  exports:[
    LoadingAnimationComponent,
    SearchBarComponent,
    AgmCoreModule,
    SearchTextComponent,
    TranslateModule,
    NgbModule,
    ComponentHolderComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    AgmCoreModule.forRoot({
      // apiKey: 'AIzaSyC0-LniG_HVw1PsOOha546Xl2LdCVOtAl4',
    }),
    FormsModule,
    NgbModule
  ]
})
export class SharedModule { }
